import React from "react";

import {Modal} from "@mantine/core";

const ActionMenu = (props) => {
	const actions = props.actions || [];

	function handleAction(action) {
		if (props.onClose) {
			props.onClose();
		}
		if (action && action.onPress) {
			action.onPress();
		}
	}

	return (
		<Modal
			title={props.title}
			opened={props.opened}
			centered={true}
			radius="xl"
			styles={{
				title: {margin: "auto", fontWeight: "bold", fontSize: "16px"},
				body: {fontWeight: "lighter"},
			}}
			onClose={() => props.onClose && props.onClose()}
		>
			<div className={"flex flex-col"} data-testid={props.testId}>
				{props.message ? (
					<p className={"text-center font-normal"}>{props.message}</p>
				) : null}
				<div className={"flex flex-col gap-2 mt-5"}>
					{actions.map((action) => (
						<button
							key={action.id || action.label}
							type="button"
							data-testid={action.testId}
							onClick={() => handleAction(action)}
							className={
								"bg-green text-white rounded-3xl px-6 py-2 self-stretch"
							}
						>
							{action.label}
						</button>
					))}
					<button
						type="button"
						data-testid={props.cancelTestId}
						onClick={() => props.onClose && props.onClose()}
						className={
							"bg-gray text-white rounded-3xl px-6 py-2 self-stretch"
						}
					>
						{props.cancelLabel}
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default ActionMenu;
